export const sharedGroupCheckboxStyles = {
  rootGrid: {
    mt: 0,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
  },
  selectAllBox: {
    display: 'flex',
    alignItems: 'center',
    ml: 1,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    p: 2,
  },
  groupPaper: {
    p: 2,
    height: 'fit-content',
    border: '1px solid #e5e7eb',
    borderTop: '2px solid #cbd5e1',
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    pb: 1,
    mb: 1,
    borderBottom: '1px solid #e5e7eb',
  },
  groupTitle: {
    fontWeight: 200,
    color: '#374151',
    ml: 1,
  },
  permissionItemRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '25px',
  },
  permissionCheckbox: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.1rem',
    },
  },
  permissionLabel: {
    fontSize: '0.875rem',
    ml: 1,
    color: '#6b7280',
    lineHeight: 1.2,
  },
};
